import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Product from '@/components/Product'
import Manufacturer from '@/components/Manufacturer'
import Contact from '@/components/Contact'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/:lang/',
      name: 'Home',
      component: Home
    },
    {
      path: '/:lang/product',
      redirect: { name: 'Home' }
    },
    {
      path: '/:lang/product/:id/:slug',
      name: 'Product',
      component: Product
    },
    {
      path: '/:lang/manufacturer',
      name: 'Manufacturer',
      component: Manufacturer
    },
    {
      path: '/:lang/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/',
      redirect: { name: 'Home', params: { lang: 'th' } }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js